enum AuctionPriceType {
  AUCTION = 'AUCTION',
  FIXED_PRICE = 'FIXED_PRICE',
  WANT_TO_BUY = 'WANT_TO_BUY'
}

const config = {
  [AuctionPriceType.AUCTION]: {
    title: 'Auction',
    description: 'Set a starting price and let the bidders drive it up.',
    tooltip: null,
    value: AuctionPriceType.AUCTION
  },
  [AuctionPriceType.FIXED_PRICE]: {
    title: 'Fixed price offer',
    description: 'Set the exact price you want to earn for the immediate sale of your item.',
    tooltip:
      'Interested parties may offer you another price, but it may not be less than 70% of the original amount. It is up to you to accept or reject price proposals.',
    value: AuctionPriceType.FIXED_PRICE
  }
  //   [AuctionPriceType.WANT_TO_BUY]: {
  //     title: 'Want to Buy',
  //     description: 'Want to Buy description',
  //     value: AuctionPriceType.WANT_TO_BUY
  //   }
};

export { config as priceTypes, AuctionPriceType };
